export const RESERVATION_NUMBERS = 'RESERVATION_NUMBERS'
export const RESERVATION_NUMBER = 'RESERVATION_NUMBER'
export const RESERVATION_NUMBER_RESERVE = 'RESERVATION_NUMBER_RESERVE'
export const RESERVATION_NUMBER_SELL = 'RESERVATION_NUMBER_SELL'
export const RESERVATION_NUMBER_IMPORT = 'RESERVATION_NUMBER_IMPORT'
export const RESERVATION_NUMBER_ACTIONS_LOGS = 'RESERVATION_NUMBER_ACTIONS_LOGS'
export const RESERVATION_NUMBER_SERVICE = 'RESERVATION_NUMBER_SERVICE'

export default {
    RESERVATION_NUMBERS,
    RESERVATION_NUMBER,
    RESERVATION_NUMBER_RESERVE,
    RESERVATION_NUMBER_SELL,
    RESERVATION_NUMBER_IMPORT,
    RESERVATION_NUMBER_ACTIONS_LOGS,
    RESERVATION_NUMBER_SERVICE
}